
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'AppProductInfoSection',
  props: {
    subBrandName: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'rounded',
      validator: v => ['sharp', 'rounded', 'circle'].includes(v)
    },
    basicPadding: {
      type: Number,
      default: 16
    },
    imageSize: {
      type: Number,
      default: 56
    },
    review: {
      type: Object,
      default: () => {}
    },
    forcedDevice: {
      type: String,
      default: null,
      validator: v => ['pc', 'mobile'].includes(v)
    }
  },
  computed: {
    ...mapGetters('widget', ['device']),
    ...mapState('widget', ['widget']),
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings']),
    styleProps() {
      return {
        '--basic-padding': `${this.basicPadding}px`,
        '--image-size': `${this.imageSize}px`
      };
    },
    currentDevice() {
      return this.forcedDevice || this.device;
    }
  },
  methods: {
    clickProduct() {
      this.windowService.redirectTo(this.review.product_url);
    }
  }
};
